import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DigiServiceService = /** @class */ (function () {
    function DigiServiceService(http) {
        this.http = http;
    }
    DigiServiceService.prototype.getDigiParameters = function () {
        return this.http.get('getDigiParameters');
    };
    DigiServiceService.prototype.addGenerator = function (data) {
        return this.http.post('addDigiManager', data);
    };
    DigiServiceService.prototype.UpdateGenerator = function (data) {
        return this.http.post('updateDigiManager', data);
    };
    DigiServiceService.prototype.getGenerators = function () {
        return this.http.get("getGenetors");
    };
    DigiServiceService.prototype.deleteGenerators = function (data) {
        return this.http.post("deleteGenetors", data);
    };
    DigiServiceService.prototype.getDigiIds = function (data) {
        return this.http.post("getGenetorsId", data);
    };
    DigiServiceService.prototype.getDigiLastData = function (data) {
        return this.http.post("getDigiLastData", data);
    };
    DigiServiceService.prototype.getReportData = function (data) {
        return this.http.post("getReportData", data);
    };
    DigiServiceService.prototype.getGeneratorByDeviceid = function (data) {
        return this.http.post("getGeneratorByDeviceid", data);
    };
    DigiServiceService.prototype.getAlerts = function (data) {
        return this.http.post("getAlertsByDeviceId", data);
    };
    DigiServiceService.prototype.getDeviceStatus = function (data) {
        return this.http.post("getDeviceStatus", data);
    };
    DigiServiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DigiServiceService_Factory() { return new DigiServiceService(i0.ɵɵinject(i1.HttpClient)); }, token: DigiServiceService, providedIn: "root" });
    return DigiServiceService;
}());
export { DigiServiceService };
